<template>
  <div>
    <div>
      <CountBadge
        :ariaLabel="badgeAriaLabel"
        :class="$style.whatsNewCount"
        :count="unreadWhatsNewItemsCount"
        :data-test-id="$testId('badge')"
      >
        <IconButton
          :class="$style.button"
          :data-test-id="$testId('button')"
          hasNoBackground
          icon="whatsNew"
          text="What's New"
          type="secondary"
          @click="openPanelAndHandleClose"
        />
      </CountBadge>
    </div>
  </div>
</template>

<script>
import { CountBadge, IconButton } from '@jumpcloud/ui-components';
import { mapActions, mapGetters } from 'vuex';

const knowledgeModule = 'KnowledgeModule';

export default {
  name: 'HeaderItemWhatsNew',

  components: {
    CountBadge,
    IconButton,
  },

  emits: ['click', 'openWhatsNewPanel'],

  computed: {
    ...mapGetters(knowledgeModule, ['unreadWhatsNewItemsCount']),

    badgeAriaLabel() {
      return this.unreadWhatsNewItemsCount > 0
        ? `What's New badge shows ${this.unreadWhatsNewItemsCount} unread messages.`
        : '';
    },
  },

  mounted() {
    this.initKnowledgeArticles();
  },

  methods: {
    ...mapActions(knowledgeModule, [
      'fetchWhatsNew',
      'whatsNewItems',
    ]),

    async initKnowledgeArticles() {
      // fetch if we haven't fetched articles yet
      if (!this.whatsNewItems.length) {
        await this.fetchWhatsNew();
      }
    },

    openPanelAndHandleClose() {
      this.$emit('openWhatsNewPanel');
      this.$emit('click');
    },
  },
};
</script>

<style scoped module>
.button {
  --icon-button-spacing: var(--jc-spacer-small);
}

.whatsNewCount /deep/ > span:last-child {
  margin-left: var(--jc-spacer-small);
}

.whatsNewCount:hover /deep/ > span:last-child {
  background: var(--jc-color-success-base);
}
</style>
